export default __webpack_public_path__ + "static/tick-88dca8d0842de2082cd3fe8e64a9d718.gif";